import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { renderTableTitle } from "@/utils/render.jsx";
import { initialInvite } from "@/service/structure";
export default {
  name: "AllJoin",
  data() {
    return {
      modal: {
        visible: false,
        loading: false
      },
      config: {
        map: {
          dataPath: "data.retVal.datas",
          message: "msg",
          totalPath: "data.retVal.totalRows"
        },
        ref: "proTable",
        toolBarActions: ["refresh", "fullscreen", "rowSetting"],
        format: {
          formatCurrent: "(page.current - 1) * page.pageSize"
        },
        request: "/api/userOrganizationAssociate/member/page",
        search: {
          value: {
            orgId: "",
            search: "",
            status: "0"
          }
        },
        columns: [{
          type: "selection",
          width: 60,
          align: "center"
        }, {
          title: $t("fqmy2", "姓名"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "userName",
          notShowSearch: true,
          notShowForm: true
        }, {
          title: $t("haa72", "手机"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "mobile",
          notShowSearch: true,
          notShowForm: true
        }, {
          title: $t("padf2", "邮箱"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "userEmail",
          notShowSearch: true,
          notShowForm: true
        }],
        table: {
          stripe: false,
          "show-summary": false
        },
        page: {
          "show-elevator": false
        }
        // hide: {
        //   toolBar: true,
        // },
      },
      allJoinNumber: 0,
      selectUser: []
    };
  },
  computed: {
    selectUserNumber() {
      return this.selectUser.length;
    }
  },
  methods: {
    clean() {
      this.selectUser = [];
      this.allJoinNumber = 0;
      this.modal.visible = false;
    },
    open(orgId, allJoinNumber) {
      this.config.search.value.orgId = orgId;
      this.allJoinNumber = allJoinNumber;
      this.modal.visible = true;
    },
    async onCommit() {
      this.modal.loading = true;
      if (this.selectUserNumber === 0) {
        this.$Message.error($t("2ehz0a5", "请选择用户"));
        this.modal.loading = false;
        return;
      }
      const params = {
        userIds: this.selectUser.map(v => v.userId).join(",")
      };
      let res = await initialInvite(params);
      if (res.data && res.data.result === 0) {
        this.modal.loading = false;
        this.$Message.success($t("b65a734", "发送成功"));
        this.$emit("update");
        this.clean();
      } else {
        this.modal.loading = false;
      }
    },
    onSelectUser(arr) {
      this.selectUser = arr;
    }
  }
};